import styled, { keyframes } from 'styled-components';

const fadeFromBottomAnimation = keyframes`
  from { opacity: 0; transform: translateY(60px); }
  to { opacity: 1 }
`;

export const LeftBox = styled.aside`
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  max-width: 480px;
  width: 100%;

  animation: ${fadeFromBottomAnimation} 0.7s ease-out forwards;
  opacity: 0;
  animation-delay: 0.2s;

  gap: ${({ theme }) => theme.spacing.lg};

  img {
    object-position: left;
    object-fit: contain;
  }

  h1 {
    color: ${({ theme }) => theme.colors.onBackground};
    font-size: 48px;
    line-height: 64px;
    font-weight: bold;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    align-items: center;

    img {
      object-position: center;
    }

    h1 {
      text-align: center;
      font-size: 32px;
      max-width: 70%;
      line-height: 48px;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    h1 {
      font-size: 24px;
      line-height: 42px;
    }
  }
`;

export const Form = styled.div`
  max-width: 480px;
  width: 100%;

  overflow: hidden;

  background: ${({ theme }) => theme.colors.surface};
  padding: ${({ theme }) => theme.spacing.xxlg};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  border: ${({ theme }) => `1px solid ${theme.colors.gray[100]}`};

  animation: ${fadeFromBottomAnimation} 0.7s ease-out forwards;
  opacity: 0;
  animation-delay: 0.12s;

  > fieldset {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.sm};

    margin-bottom: ${({ theme }) => theme.spacing.lg};
  }

  #button {
    width: 100%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: ${({ theme }) => theme.spacing.xlg};
  }

  @media (max-width: 500px) {
    padding: ${({ theme }) => theme.spacing.lg};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: ${({ theme }) => theme.spacing.md};
  }
`;

export const FormFooter = styled.footer`
  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: ${({ theme }) => theme.spacing.md};

  span {
    text-align: center;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.onSurface};
    line-height: 24px;

    a {
      color: ${({ theme }) => theme.colors.primary};
      white-space: nowrap;
      font-weight: 700;

      transition: filter 0.3s ease-in-out;

      &:hover {
        filter: brightness(0.75);
      }
    }
  }
`;
